// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ResultadoFinanceiro_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /relatorios/resultado_financeiro/lista_resultado.
 *
 * The model assembles a heterogeneous list of report rows: faturamento /
 * ticket-medio / CAC / qtd_compromissos line, then total_compromissos, then
 * then the recebido line, then one row per despesa categoria, then
 * total_despesas, total_investimentos, resultado. Each row carries
 * `Titulo` / `Tipo` / `Formatacao` plus dynamically-keyed per-month columns
 * ("MM-YYYY"), per-month percentage keys ("percent_MM-YYYY"), per-month
 * faturamento ratio keys ("percent_faturamento_MM-YYYY") and per-month
 * recebido ratio keys ("percent_recebido_MM-YYYY") — the column set is a
 * function of the date filter, so we cannot project a Row.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ResultadoFinanceiro_ListaResponseDados = Record<string, string | number | null>[];

export type ResultadoFinanceiro_ListaResponse = ApiResponse<ResultadoFinanceiro_ListaResponseDados>;

registerResponseContract('ResultadoFinanceiro_ListaResponse', {})
